const isLoading = (state) => state.isLoading;

export {isLoading};